/* eslint-disable import/no-unresolved */
/* eslint-disable no-console */
import React from 'react';

// Icons imports, figma lib : https://www.figma.com/community/file/1014161990176840236/vuesax-icons
import Add from '../../../assets/icons/add.svg?react';
import AddSquareOutline from '../../../assets/icons/add-square-outline.svg?react';
import ArrowDown from '../../../assets/icons/arrow-down.svg?react';
import ArrowSquareLeft from '../../../assets/icons/arrow-square-left.svg?react';
import ArrowRight from '../../../assets/icons/arrow-right.svg?react';
import ArrowDownBulk from '../../../assets/icons/arrow-down-bulk.svg?react';
import ArrowUpBulk from '../../../assets/icons/arrow-up-bulk.svg?react';
import ArrowUpRightMd from '../../../assets/icons/arrow-up-right-md.svg?react';
import BookmarkFill from '../../../assets/icons/bookmark-fill.svg?react';
import BookmarkOutline from '../../../assets/icons/bookmark-outline.svg?react';
import Calendar from '../../../assets/icons/calendar.svg?react';
import Calendar12 from '../../../assets/icons/calendar-12.svg?react';
import CalendarMain from '../../../assets/icons/calendar-main.svg?react';
import ChevronLeft from '../../../assets/icons/chevron-left.svg?react';
import ChevronRight from '../../../assets/icons/chevron-right.svg?react';
import ChevronDownRange from '../../../assets/icons/chevron-down-range.svg?react';
import ChevronLeftLinear from '../../../assets/icons/chevron-left-linear.svg?react';
import ChevronLeftRange from '../../../assets/icons/chevron-left-range.svg?react';
import ChevronRightLinear from '../../../assets/icons/chevron-right-linear.svg?react';
import ChevronRightRange from '../../../assets/icons/chevron-right-range.svg?react';
import ChevronUpRange from '../../../assets/icons/chevron-up-range.svg?react';
import CloseMd from '../../../assets/icons/close-md.svg?react';
import CloseSquare from '../../../assets/icons/close-square-outline.svg?react';
import Clock from '../../../assets/icons/clock.svg?react';
import CircleCheck from '../../../assets/icons/circle-check.svg?react';
import DragHorizontal from '../../../assets/icons/drag-horizontal.svg?react';
import Edit2 from '../../../assets/icons/edit-2.svg?react';
import Export from '../../../assets/icons/export.svg?react';
import Eye from '../../../assets/icons/eye.svg?react';
import EyeSlash from '../../../assets/icons/eye-slash.svg?react';
import Filter from '../../../assets/icons/filter.svg?react';
import InfoCircle from '../../../assets/icons/info-circle.svg?react';
import Import from '../../../assets/icons/import.svg?react';
import Like from '../../../assets/icons/like.svg?react';
import Lock from '../../../assets/icons/lock.svg?react';
import Map from '../../../assets/icons/map.svg?react';
import Menu from '../../../assets/icons/menu.svg?react';
import Minus from '../../../assets/icons/minus.svg?react';
import Home from '../../../assets/icons/home.svg?react';
import MessageQuestion from '../../../assets/icons/message-question.svg?react';
import MoreVertical from '../../../assets/icons/more-vertical.svg?react';
import Refresh from '../../../assets/icons/refresh.svg?react';
import SearchNormal from '../../../assets/icons/search-normal.svg?react';
import Setting2 from '../../../assets/icons/setting-2.svg?react';
import Setting5 from '../../../assets/icons/setting-5.svg?react';
import Sort from '../../../assets/icons/sort.svg?react';
import Stickynote from '../../../assets/icons/stickynote.svg?react';
import Star from '../../../assets/icons/star.svg?react';
import StarFilled from '../../../assets/icons/star-filled.svg?react';
import Times from '../../../assets/icons/times.svg?react';
import Task from '../../../assets/icons/task.svg?react';
import TickSquare from '../../../assets/icons/tick-square-outline.svg?react';
import TrashEmpty from '../../../assets/icons/trash-empty.svg?react';
import UnfoldLess from '../../../assets/icons/unfold-less.svg?react';
import UnfoldMore from '../../../assets/icons/unfold-more.svg?react';

/**
 * @typedef {keyof typeof availablePictos} AvailableIconName
 */

export const availablePictos = {
  add: Add,
  'add-square-outline': AddSquareOutline,
  'arrow-down-bulk': ArrowDownBulk,
  'arrow-down': ArrowDown,
  'arrow-square-left': ArrowSquareLeft,
  'arrow-right': ArrowRight,
  'arrow-up-bulk': ArrowUpBulk,
  'arrow-up-right-md': ArrowUpRightMd,
  'bookmark-fill': BookmarkFill,
  'bookmark-outline': BookmarkOutline,
  calendar: Calendar,
  'calendar-12': Calendar12,
  'calendar-main': CalendarMain,
  'chevron-down-range': ChevronDownRange,
  'chevron-up-range': ChevronUpRange,
  'chevron-left': ChevronLeft,
  'chevron-left-linear': ChevronLeftLinear,
  'chevron-left-range': ChevronLeftRange,
  'chevron-right': ChevronRight,
  'chevron-right-linear': ChevronRightLinear,
  'chevron-right-range': ChevronRightRange,
  'close-square': CloseSquare,
  'close-md': CloseMd,
  clock: Clock,
  'circle-check': CircleCheck,
  'drag-horizontal': DragHorizontal,
  'edit-2': Edit2,
  export: Export,
  eye: Eye,
  'eye-slash': EyeSlash,
  filter: Filter,
  home: Home,
  import: Import,
  like: Like,
  lock: Lock,
  map: Map,
  menu: Menu,
  minus: Minus,
  'message-question': MessageQuestion,
  'more-vertical': MoreVertical,
  refresh: Refresh,
  'search-normal': SearchNormal,
  'setting-2': Setting2,
  'setting-5': Setting5,
  sort: Sort,
  star: Star,
  stickynote: Stickynote,
  'star-filled': StarFilled,
  task: Task,
  times: Times,
  'tick-square': TickSquare,
  'trash-empty': TrashEmpty,
  'unfold-less': UnfoldLess,
  'unfold-more': UnfoldMore,
  'info-circle': InfoCircle,
};

/**
 * Display an svg icon
 * @param {object} params
 * @param {AvailableIconName} params.icon
 * @param {string} [params.className]
 * @param {object} [params.props]
 * @returns {JSX.Element | null}
 */
function Picto({ icon, ...props }) {
  if (icon && Object.prototype.hasOwnProperty.call(availablePictos, icon)) {
    try {
      const IconComponent = availablePictos[icon];
      return IconComponent ? React.createElement(IconComponent, props) : null;
    } catch (error) {
      console.error(`"${icon}":`, error);
    }
  }

  return null;
}

export default Picto;
